module.exports = __webpack_public_path__ + "Cosmos_Cosplay.webp?53475f66f3f2fc8794a3868e9942a7ba";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Cosmos_Cosplay.webp
// module id = 63
// module chunks = 0